// extracted by mini-css-extract-plugin
export default {"text":"amP4","deactivated":"_1VMu","image":"_7AJe","activated":"_2s3G","cellAlert":"_26Cq","showMoreText":"w6na"};